import * as React from 'react';
import {Icon, SemanticICONS, SemanticSIZES} from "semantic-ui-react";

interface IToggleButtonProps {
    onClick: (toggled?: boolean) => void;
    label?: string;
    labelPosition?: "before" | "after";
    icon?: SemanticICONS;
    style?: React.CSSProperties;
    disabled?: boolean;
    raised?: boolean;
    className?: string;
    /** A button can be aligned to the left or right of its container. */
    floated?: 'left' | 'right';
    toggled?: boolean;
    /** A button can have different sizes. */
    size?: SemanticSIZES;
}

interface IToggleButtonState {
    toggled: boolean;
}

export class ToggleButton extends React.Component<IToggleButtonProps, IToggleButtonState> {
    constructor(props: IToggleButtonProps) {
        super(props);
        this.state = {
            toggled: false,
        };
    }

    componentDidUpdate(prevProps:Readonly<IToggleButtonProps>, prevState: Readonly<IToggleButtonState>): void {
        if(this.state.toggled !== this.props.toggled && this.props.toggled !== undefined) {
            this.setState({toggled: this.props.toggled});
        }
    }

    onClick = () => {
        this.setState({toggled: !this.state.toggled}, () => this.props.onClick(this.state.toggled));
    }

    render() {
        const {props} = this;
        // If neither label nor icon is applied, throw an error at run time
        if (!this.props.label && !props.icon) {
            throw new Error("Either property label or icon of Button is required!");
        }

        let cont = (
            <>
                {props.icon ? <Icon name={props.icon}/> : null}
                {props.label || null}
            </>
        );

        if (props.label)
            if (props.labelPosition === 'before') {
                cont = (
                    <>
                        {props.label}
                        {props.icon ? <Icon name={props.icon} className='after'/> : null}
                    </>
                );
            } else if (props.labelPosition === 'after') {
                cont = (
                    <>
                        {props.icon ? <Icon name={props.icon} className='before'/> : null}
                        {props.label}
                    </>
                );
            }

        let disabled: string = props.disabled ? 'disabled ' : '';
        let toggled: string = this.state.toggled ? 'toggled ' : '';

        return (
            <button
                onClick={this.onClick}
                className={'btn ' + toggled + disabled + props.className}
                disabled={props.disabled}
            >
                {cont}
            </button>
        );
    }
}

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/ToggleButton.tsx